<template>
  <div class="authentication-wrapper authentication-3 nav-padding-sm">
    <div class="authentication-inner">
      <div
        class="d-none d-lg-flex col-lg-8 align-items-center ui-bg-cover
         ui-bg-overlay-container p-5">
        <div class="ui-bg-overlay bg-dark opacity-50"></div>

        <div class="w-100 text-white px-5">
          <h1 class="display-2 font-weight-bolder mb-4">MAAK MARKETING<br>MEETBAAR</h1>
          <div class="text-large font-weight-light">
            {{ $t('sentence.register_organisation') }}
          </div>
        </div>
      </div>

      <div class="d-flex col-lg-4 bg-white p-5">
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">
            <div class="d-flex justify-content-center align-items-center">
              <div class="ui-w-60 d-flex justify-content-center">
                <img
                  class="w-50"
                  src="@/common/assets/img/logo.png"
                  alt="commercialreview"
                />
              </div>
            </div>
            <hr />
            <div v-if="!isOrganisation && !isUser">
              <h4 class="text-center text-lighter font-weight-normal mt-5 mb-5 mb-0">
                {{ $t('sentence.register_as') }}
              </h4>

              <div class="row mb-3">
                <div class="col-md-6">
                  <v-button
                    :text="$tc('word.user', 1)"
                    :translate-text="false"
                    icon="user"
                    :block="true"
                    :route-to="{name: 'register-as', params: {as: 'user'}}"
                  />
                </div>
                <div class="col-md-6">
                  <v-button
                    :text="$tc('word.organisation')"
                    :translate-text="false"
                    icon="building"
                    :block="true"
                    :route-to="{name: 'register-as', params: {as: 'organisation'}}"
                  />
                </div>
              </div>
            </div>

            <v-register-user
              v-if="isUser"
              @authenticated="goToDashboard"
            />
            <v-register-organisation
              v-else-if="isOrganisation"
              @authenticated="goToDashboard"
            />

            <hr />

            <div class="text-center text-muted">
              {{ $t('phrase.already_an_account_question') }}
              <router-link
                :to="{name: 'login'}"
                id="register-login-link"
              >{{ $t('word.login') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import RegisterOrganisation from '@/common/components/auth/RegisterOrganisation.vue';
import RegisterUser from '@/common/components/auth/RegisterUser.vue';
import { notify } from '@/common/utils/notify';

export default {
  name: 'Register',
  data() {
    return {
      organisationType: null,
      userType: null,
      totalPrice: null,
    };
  },
  components: {
    'v-button': Button,
    'v-register-organisation': RegisterOrganisation,
    'v-register-user': RegisterUser,
  },
  computed: {
    isOrganisation() {
      return this.$route.params.as === 'organisation';
    },
    isUser() {
      return this.$route.params.as === 'user';
    },
  },
  methods: {
    goToDashboard() {
      notify('phrase.logged_in');
      this.$router.push(this.$route.query.next || { name: 'dashboard' });
    },
  },
};
</script>

<style scoped>
@import "../../common/assets/css/authentication.css";
</style>
